import { Close } from '@mui/icons-material';
import { Button, Dialog, DialogContent, DialogTitle, FormControl, IconButton, InputLabel, MenuItem, Select, TextField } from '@mui/material'
import React, { useEffect } from 'react'
import { ApiDataClient } from '../../Api/ApiDataClient';
import { ProjectDTO, ProjectType } from '../../Api/ApiServer';

interface UpdateProjectDialogProps {
    open: boolean;
    project?: ProjectDTO | undefined;
    onClose: () => void;
    onRefresh?: () => void;
}
export default function UpdateProjectDialog(props: UpdateProjectDialogProps) {
    const { open, project, onClose, onRefresh } = props;

    const [name, setName] = React.useState<string>();
    const [type, setType] = React.useState<ProjectType>(ProjectType.None);
    const [id, setId] = React.useState<number>();
    const [buttonDisabled, setButtonDisabled] = React.useState<boolean>(false);

    useEffect(() => {
        if (project){
            setName(project.name);
            setType(project.type ?? ProjectType.None);
            setId(project.id);
        }
        else {
            setName(undefined);
            setType(ProjectType.None);
            setId(undefined);
        }
    }, [project]);

    return (
        <Dialog
            open={open}
            onClose={() => { onClose() }}
            aria-labelledby="create-dialog-title"
            aria-describedby="create-dialog-description"
        >
            <DialogTitle id="create-project-dialog-title" sx={{ background: '#F5F5F5'}}>
                <div  >
                    <div style={{ marginRight: '20px', minWidth: '200px' }}>Úprava projektu</div>
                    <IconButton sx={{ width: '30px', height: '30px', right: '20px', top: '18px', float: 'right', position: 'absolute' }}
                        onClick={() => { setName(undefined); onClose(); }}><Close /></IconButton>
                </div>
            </DialogTitle>
            <DialogContent>
                    <div>
                        <TextField sx={{ margin: '12px', width: '526px' }} label={'Název projektu'}
                            size='small'
                            name='userName'
                            variant='outlined'
                            value={name}
                            error={!name}
                            onChange={(e) => { setName(e.target.value) }} />
                        <div style={{ margin: '12px', width: '526px' }}>
                            <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                                <InputLabel id="demo-simple-select-standard-label">Typ</InputLabel>
                                <Select
                                    labelId="demo-simple-select-standard-label"
                                    id="demo-simple-select-standard"
                                    value={type}
                                    onChange={(v) => { if (v.target.value) setType(v.target.value as ProjectType) }  }
                                    label="Typ"
                                >
                                    <MenuItem value={ProjectType.None}>Neurčeno</MenuItem>
                                    <MenuItem value={ProjectType.Road}>Silnice</MenuItem>
                                    <MenuItem value={ProjectType.Railway}>Železnice</MenuItem>
                                    <MenuItem value={ProjectType.RoadBridge}>Silniční most</MenuItem>
                                    <MenuItem value={ProjectType.RailwayBridge}>Železniční most</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '16px' }}>
                            <Button variant='contained' sx={{ margin: 'auto' }} disabled={name === undefined || buttonDisabled} onClick={() => {
                                if (name && type !== undefined && id) {
                                    setButtonDisabled(true);
                                    new ApiDataClient().UpdateProject(name, type, id).then((v) => {
                                        setButtonDisabled(false);

                                        if (onRefresh)
                                            onRefresh();

                                        onClose();
                                    });
                                }
                            }}>Uložit</Button>
                        </div>
                    </div>
            </DialogContent>
        </Dialog>
    )
}
